import type { ReactNode } from "react";
import { useLocale } from "../state/i18n";

type FormFieldLabelProps = {
  htmlFor: string;
  children: ReactNode;
  required?: boolean;
  optional?: boolean;
  /** Asterisk for this registration form. Other forms keep the written required mark. */
  presentation?: "words" | "asterisk";
};

export function FormFieldLabel({
  htmlFor,
  children,
  required = false,
  optional = false,
  presentation = "words",
}: FormFieldLabelProps) {
  const { t } = useLocale();
  const requiredLabel = t("register.required");
  return (
    <label htmlFor={htmlFor}>
      {children}
      {required && presentation === "asterisk" ? (
        <>
          <abbr className="field-mark field-mark--star" title={requiredLabel}>
            *
          </abbr>
          <span className="sr-only"> {requiredLabel}</span>
        </>
      ) : null}
      {required && presentation === "words" ? (
        <span className="field-mark field-mark--required"> {requiredLabel}</span>
      ) : null}
      {optional ? (
        <span className="field-mark field-mark--optional"> {t("register.optional")}</span>
      ) : null}
    </label>
  );
}
